import { createContext, type HTMLAttributes, type RefObject, useRef } from 'react';
import styled from 'styled-components';

import { type FlexShorthandProps, VFlex } from '@/components/base';

import KeyboardNavigatorItem from './KeyboardNavigatorItem';

const KeyboardNavigator = () => {};

export const KeyboardNavigatorContext = createContext<{
  listRef: RefObject<HTMLDivElement> | null;
}>({
  listRef: null,
});

const KeyboardNavigatorList = (
  props: HTMLAttributes<HTMLDivElement> & FlexShorthandProps,
) => {
  const ref = useRef<HTMLDivElement>(null);
  return (
    <KeyboardNavigatorContext.Provider value={{ listRef: ref }}>
      <ListStyle {...props} ref={ref} />
    </KeyboardNavigatorContext.Provider>
  );
};

const ListStyle = styled(VFlex)`
  gap: 12px;
  padding: 20px 0px 20px 12px;
  overflow: auto;
  scrollbar-gutter: stable;
`;

KeyboardNavigator.List = KeyboardNavigatorList;
KeyboardNavigator.Item = KeyboardNavigatorItem;

export default KeyboardNavigator;
